var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBlurPiece = function SvgBlurPiece(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 357,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 5.107a5 5 0 00-5-5H.82v355.92H123a5 5 0 005-5V5.107z",
    fill: "url(#blurPiece_svg__paint0_linear_6026_3226)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blurPiece_svg__paint0_linear_6026_3226",
    x1: 64.41,
    y1: 0.107,
    x2: 9.514,
    y2: 0.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgBlurPiece;